import React, {useEffect, useState} from 'react';
import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import Loading from "../UI/Loading";
import Button from "../UI/Button";

const CheckoutForm = ({success_url = "/app/payment_recap"}) => {

    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [paymentReady, setPaymentReady] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");
        setError("");

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setIsLoading(true);

        const {error} = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: process.env.REACT_APP_WEBSITE_DOMAIN + success_url,
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            setError(error.message);
        } else {
            setError("Qualcosa è andato storto.");
        }

        setIsLoading(false);
    };

    const onPaymentFormReady = () => {
        setPaymentReady(true);
    }

    useEffect(() => {
        if (!stripe) {
            return;
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecret) {
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({paymentIntent}) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage("Pagamento completato!");
                    break;
                case "processing":
                    setMessage("Stiamo processando il tuo pagamento.");
                    break;
                case "requires_payment_method":
                    setError("Pagamento fallito, riprova.");
                    break;
                default:
                    setError("Qualcosa è andato storto.");
                    break;
            }
            console.log("DONE")
        });
    }, [stripe]);

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            {message && <div id="payment-message">{message}</div>}
            {error && <div className="text-red-500 font-bold mb-4">{error}</div>}

            <PaymentElement id="payment-element" className={isLoading ? "hidden" : ""} onReady={onPaymentFormReady}/>

            {isLoading ?
                <Loading label="Stiamo processando il tuo pagamento" className="font-bold text-ea_green_to"/>
                :
                <Button disabled={isLoading || !stripe || !elements || !paymentReady} id="submit"
                        className={`mt-4 w-full ${!paymentReady ? "hidden" : ""}`}>Paga
                    Ora</Button>
            }
            {/* Show any error or success messages */}

        </form>
    );
}

export default CheckoutForm;